/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from "react";
import PropTypes from "prop-types";
import AxiosClient from "../../../../_helpers/http.helper";
import config from "../../../../config";
import urlHelper from "../../../../_helpers/url.format.server.helper";
import ModalDialog from "../../../widgets/ModalDialog/ModalDialog";
import { StaticAlert } from '@pearson-components/elements-sdk/build/dist.elements-sdk';

export default class PrintPriceModal extends React.Component {

    static get propTypes() {
        return {
            priceAdminUpdateDTO: PropTypes.object.isRequired,
            activeCollection: PropTypes.object.isRequired,
            collectionId: PropTypes.string.isRequired,
            loadInitialData: PropTypes.func.isRequired
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            priceAdminUpdateDTO:{
                basePrice: "",
                calculatedPrice: "",
                calculatedPriceAmount: "",
                discountPercent: "",
                permissions: "",
                priceGroupId: "",
                productionCosts: "",
                royalties: "",
                specialPrice: "",
            },

            saveDisabled : true,
            selectedRadio : "calculated",
            showAlert: false,
            type: "",
            message: ""
        };
        this.updateOverridePrice = this.updateOverridePrice.bind(this);
        this.handleDiscountChange = this.handleDiscountChange.bind(this);
        this.handleSpecialPriceChange = this.handleSpecialPriceChange.bind(this);
        this.handleOptionChange = this.handleOptionChange.bind(this);
        this.updateCalculatedAmount = this.updateCalculatedAmount.bind(this);
        this.validate = this.validate.bind(this);
    }
    componentDidMount() {
        this.setState({
            priceAdminUpdateDTO: {
                basePrice: this.props.priceAdminUpdateDTO.basePrice,
                calculatedPrice: this.props.priceAdminUpdateDTO.calculatedPrice,
                calculatedPriceAmount: this.props.priceAdminUpdateDTO.calculatedPriceAmount,
                discountPercent: this.props.priceAdminUpdateDTO.discountPercent,
                permissions: this.props.priceAdminUpdateDTO.permissions,
                priceGroupId: this.props.priceAdminUpdateDTO.priceGroupId,
                productionCosts: this.props.priceAdminUpdateDTO.productionCosts,
                royalties: this.props.priceAdminUpdateDTO.royalties,
                specialPrice: this.props.priceAdminUpdateDTO.specialPrice,
            },
            selectedRadio: this.props.selectedRadio
        });
    }
    getPriceGroupId() {
        const {code} = this.props.activeCollection.geo;
        let priceGroupId = "";
        if (code === 'US') {
            priceGroupId= "244f7f8e-1e6b-11e4-8276-03d31c1207ee";
        } else if (code === 'CA') {
            priceGroupId= "0492cecc-4df7-11e6-a6a1-122189a19418";
        }
        return priceGroupId;
    }
    handleDiscountChange(value) {
        if (Number(value) <= 100) {
            this.setState(prevState => {
                return {
                    priceAdminUpdateDTO: {
                        ...prevState.priceAdminUpdateDTO,
                        discountPercent: value
                    }
                };
            });
        }
    }

    handleSpecialPriceChange(e) {
        this.setState(prevState => {
            return {
                priceAdminUpdateDTO: {
                    ...prevState.priceAdminUpdateDTO,
                    specialPrice: e
                },
                saveDisabled: false
            };
        });
    }

    handleOptionChange(e) {
        if (e.target.id === "calculated") {
            this.setState(prevState => {
                return {
                    priceAdminUpdateDTO: {
                        ...prevState.priceAdminUpdateDTO,
                        calculatedPrice: true
                    },
                    selectedRadio: "calculated"
                };
            });
        } else {
            this.setState(prevState => {
                return {
                    priceAdminUpdateDTO: {
                        ...prevState.priceAdminUpdateDTO,
                        calculatedPrice: false
                    },
                    selectedRadio: "special"
                };
            });
        }
    }

    updateCalculatedAmount(){
        this.setState(prevState => {
            return {
                priceAdminUpdateDTO: {
                    ...prevState.priceAdminUpdateDTO,
                    calculatedPriceAmount:  ( (Number(prevState.priceAdminUpdateDTO.basePrice) + Number(prevState.priceAdminUpdateDTO.royalties) + Number(prevState.priceAdminUpdateDTO.permissions) + Number(prevState.priceAdminUpdateDTO.productionCosts)) * Number(1 - prevState.priceAdminUpdateDTO.discountPercent / 100)).toFixed(2)
                }
            };
        });
    }

    validate(e){
        if (['e', 'E', '-', '+'].includes(e.key)) {
            e.preventDefault();
        }
    }

    updateOverridePrice = () => {
        let price = {
            basePrice: this.state.priceAdminUpdateDTO.basePrice,
            calculatedPrice: this.state.selectedRadio === "calculated",
            specialPrice: this.state.priceAdminUpdateDTO.specialPrice,
            calculatedPriceAmount: this.state.priceAdminUpdateDTO.calculatedPriceAmount,
            collectionId: this.props.collectionId,
            discountPercent: this.state.priceAdminUpdateDTO.discountPercent,
            priceGroupId: this.getPriceGroupId(),
            permissions: this.state.priceAdminUpdateDTO.permissions,
            productionCosts: this.state.priceAdminUpdateDTO.productionCosts,
            royalties: this.state.priceAdminUpdateDTO.royalties
        };
        const url = urlHelper.formatUrl(
            config.collectionService.baseUrl,
            config.collectionService.routes.updateOverridePrice,
            {
                collectionId: this.props.collectionId
            }
        );
        AxiosClient.post(url, price)
            .then(response => {
                this.setState({
                    showAlert: true,
                    type: "Success",
                    message: "Successfully updated."
                });
                this.props.hidePriceModal();
                this.props.loadInitialData(this.props.collectionId);
                return response.data;
            })
            .catch(error => {
                this.setState({
                    showAlert: true,
                    type: "Error",
                    message: "Error occurred while updating."
                });
                console.log("Error ", error);
            });setTimeout(
            () =>
                this.setState(
                    {
                        showAlert: false
                    }),
            2000
        );
    };
    handleRoyalties(value){
        this.setState(prevState => {
            return {
                priceAdminUpdateDTO: {
                    ...prevState.priceAdminUpdateDTO,
                    royalties: value
                }
            };
        });
    }
    handlePermissions(value){
        this.setState(prevState => {
            return {
                priceAdminUpdateDTO: {
                    ...prevState.priceAdminUpdateDTO,
                    permissions: value
                }
            };
        });
    }
    handleProductionCost(value){
        this.setState(prevState => {
            return {
                priceAdminUpdateDTO: {
                    ...prevState.priceAdminUpdateDTO,
                    productionCosts: value
                }
            };
        });
    }
    hidePriceModal = () => {
        this.props.hidePriceModal();
    }

    render() {
        const {showPriceModal} = this.props;
        return <div>
            {this.state.showAlert ? <StaticAlert type={this.state.type} message={this.state.message} /> : null}
            <ModalDialog
                showModal={showPriceModal}
                onSuccess={this.updateOverridePrice}
                onCancel={this.hidePriceModal}
                title="Print Price"
            >
                <div className="price-modal-content">
                    <div className="base-price-container">
                        <div className="pe-input-group">
                            <label className="pe-textLabelInput__label">Base price</label>
                            <div className="pe-input">
                                <button className="pe-btn" disabled={true}>$</button>
                                <input
                                    className="pe-textInput--basic base-price"
                                    value={this.state.priceAdminUpdateDTO.basePrice}
                                    disabled={true}/>
                            </div>
                        </div>
                    </div>
                    <div className="base-price-container">
                        <div className="pe-input-group">
                            <label className="pe-textLabelInput__label">Royalties</label>
                            <div className="pe-input">
                                <button className="pe-btn" disabled={true}>$</button>
                                <input
                                    type="number"
                                    id="royalties"
                                    className="pe-textInput--basic base-price"
                                    value={this.state.priceAdminUpdateDTO.royalties}
                                    onBlur={e => {
                                        this.handleRoyalties(Number(e.target.value).toFixed(2));
                                    }}
                                    onChange={e => {
                                        this.handleRoyalties(e.target.value);
                                        this.updateCalculatedAmount();
                                    }}
                                    onKeyPress={this.validate}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="base-price-container">
                        <div className="pe-input-group">
                            <label className="pe-textLabelInput__label">Permissions</label>
                            <div className="pe-input">
                                <button className="pe-btn" disabled={true}>$</button>
                                <input
                                    type="number"
                                    id="permissions"
                                    className="pe-textInput--basic base-price"
                                    value={this.state.priceAdminUpdateDTO.permissions}
                                    onBlur={e => {
                                        this.handlePermissions(Number(e.target.value).toFixed(2));
                                    }}
                                    onChange={e => {
                                        this.handlePermissions(e.target.value);
                                        this.updateCalculatedAmount();
                                    }}
                                    onKeyPress={this.validate}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="base-price-container">
                        <div className="pe-input-group">
                            <label className="pe-textLabelInput__label">Production Costs</label>
                            <div className="pe-input">
                                <button className="pe-btn" disabled={true}>$</button>
                                <input
                                    type="number"
                                    id="productionCosts"
                                    className="pe-textInput--basic base-price"
                                    value={this.state.priceAdminUpdateDTO.productionCosts}
                                    onBlur={e => {
                                        this.handleProductionCost(Number(e.target.value).toFixed(2));
                                    }}
                                    onChange={e => {
                                        this.handleProductionCost(e.target.value);
                                        this.updateCalculatedAmount();
                                    }}
                                    onKeyPress={this.validate}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="discount-container">
                        <div className="pe-input-group">
                            <label className="pe-textLabelInput__label">Discount</label>
                            <div className="pe-input">
                                <button className="pe-btn" disabled={true}>%</button>
                                <input type="number"
                                    className="pe-textInput--basic discount"
                                    value={this.state.priceAdminUpdateDTO.discountPercent !== 0 ? this.state.priceAdminUpdateDTO.discountPercent : ""}
                                    onChange={e => {
                                        this.handleDiscountChange(e.target.value);
                                        this.updateCalculatedAmount();
                                    }}
                                    onKeyPress={this.validate}/>
                            </div>
                        </div>
                    </div>
                    <div className="price-container-radio">
                        <div className="pe-radio">
                            <input type="radio" name="price-type" id="calculated"
                                checked={this.state.selectedRadio === "calculated"}
                                onChange={(e)=> this.handleOptionChange(e)}/>
                            <label className="pe-textLabelInput__label">Calculated price</label>
                        </div>
                        <div className="pe-radio special-price-radio">
                            <input type="radio" name="price-type" id="special"
                                checked={this.state.selectedRadio === "special"}
                                onChange={(e)=> this.handleOptionChange(e)}
                            />
                            <label className="pe-textLabelInput__label">Special price</label>
                        </div>
                    </div>
                    <div className="price-container-inputs">
                        <div className="pe-input">
                            <button className="pe-btn" disabled={true}>$</button>
                            <input
                                className="pe-textInput--basic" id="calculated-price"
                                value={this.state.selectedRadio === "calculated" ? this.state.priceAdminUpdateDTO.calculatedPriceAmount : ""}
                                disabled={true}/>
                        </div>
                        <div className="pe-input">
                            <button className="pe-btn" disabled={true}>$</button>
                            <input  type="number"
                                className="pe-textInput--basic" id="special-price"
                                value={this.state.selectedRadio === "special" ? this.state.priceAdminUpdateDTO.specialPrice : ""}
                                onChange={(e)=> this.handleSpecialPriceChange(e.target.value)}
                                onKeyPress={this.validate}
                            />
                        </div>
                    </div>
                </div>
            </ModalDialog>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/BookDetailsComponents/PrintPriceModal.js